<template>

  <div v-if="$store.getters.user">Erfolgreich authentifiziert</div>

</template>

<script>

  import axios from 'axios'
  axios.defaults.withCredentials = true

  export default {
    name: 'Auth',
    async created () {

       console.log('Auth created')
       if (this.$route.params.token && this.$route.params.customer_id && this.$route.params.user) {

        // prüfe den token und Login des Users
        const token       = this.$route.params.token
        const user        = this.$route.params.user
        const customer_id = this.$route.params.customer_id

        // Sprache:
        const lang = this.$route.params.lang
        if (lang) {
          this.setLang(lang)
        }

        console.log(' user: ' + user + ' customer_id: ' + customer_id)
        const pars = {
          token: token,
          customer_id: customer_id,
          user: user,
        }
        const url = process.env.VUE_APP_SERVER_URL + '/plan/checkPlanToken'
        await axios.post (
            url,
            pars, {
            headers: {
              'Content-Type': 'application/json'
            },
        }).then(
          response => {

            // console.log('checkToken response: ', JSON.stringify(response))
            if (response.data.role) { // Response ist der BiotechUser

              this.$store.commit('setUserRole', response.data.role)
              this.$store.commit('setUser',     response.data.user)
              this.$store.commit('setAnzahlCustomer', 1)
              // customer und Benutzerrechte
              // wurde die Planansicht für die App aufgerufen?
              this.$store.commit('setPlanansichtApp', true)
              const splitted = this.$route.params.customer_id.split('_')
              const customer = {
                cardcode: splitted[1],
                biotechCountry: {
                  name: splitted[0],
                },
              }
              this.setCustomerAndUserRights(customer)
              if (!this.$route.params.plan_id) {
                // PLan ohne ID oder Position aufrufen:
                this.$router.push('/Plan')
              } else {
                // Plan direkt anspringen und/oder Position mitliefern:
                const params = {
                  id: this.$route.params.plan_id,
                }
                if (this.$route.params.position_id) {
                  params.position_id = this.$route.params.position_id
                }
                this.$router.push({
                  name: 'Plan',
                  params: params,
                })
              }

            } else {
              this.$router.push('/')
            }

          }
        ).catch(error => {
          console.log('checkToken error: ', error)
          this.$router.push('/')
        })

      } else {
         console.log('kein token oder anderer parameter fehler', this.$route.params)
       }

    },
    methods: {

      setLang: function (lang) {

        this.$i18n.locale = lang

        // schicke die Sprache an den Server
        const url = process.env.VUE_APP_SERVER_URL + '/app/setLang'
        const params = {
          lang: lang,
        }
        axios.get(url, {
          params: params,
          withCredentials: true,
        })

      },

    },

  }

</script>
